import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=6af4a4ad&scoped=true"
import script from "./SupportChat.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportChat.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=6af4a4ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af4a4ad",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SupportChat.vue
// module id = 1641
// module chunks = 31